import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getStyles, addToArray } from '../../../shared/utility';

import localStyles from './Popup.scss';
const styles = getStyles(localStyles);

class Popup extends PureComponent {

    constructor(props) {
        super(props);
        this.refPopup = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
        if (this.props.fullscreenOnDevices) {
            this.setOffset();
            window.addEventListener('resize', this.setOffset);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        if (this.props.fullscreenOnDevices) {
            window.removeEventListener('resize', this.setOffset);
        }
    }

    /* * * * * * * * * *
     * EVENT HANDLERS  *
     * * * * * * * * * */
    handleClickOutside = (event) => {
        !!event.nativeEvent ? event.nativeEvent.stopImmediatePropagation() : this.props.close();
    }

    setOffset = () => {
        if(!!this.refPopup && !!this.refPopup.current) {
            if (window.innerWidth >= 500) { //$bp-xxs
                this.refPopup.current.removeAttribute('style');
                return;
            }
            const headerHeight = document.getElementById('header') ?
                Math.floor(document.getElementById('header').getBoundingClientRect().height) + 1 : 0;
            this.refPopup.current.setAttribute('style', `top:${headerHeight}px; height:${window.innerHeight - headerHeight}px;`);
        }
    }

    /* * * * * *
     * RENDER  *
     * * * * * */
    render() {
        let popupClasses = ['popup'].concat(this.props.isOpen ? 'popup--open' : null).concat(this.props.fullscreenOnDevices ? 'popup--fullscreen' : null);
        popupClasses = addToArray(this.props.classes, popupClasses);

        return this.props.isOpen ? (
            <div className={styles(popupClasses)} onClick={this.handleClickOutside} ref={this.refPopup}>
                <div className={styles('popup__arrow')}/>
                <div className={styles('popup__content', 'b--white')}>
                    {this.props.children}
                </div>
            </div>
        ) : null;
    }
}

Popup.propTypes = {
    // properties
    children: PropTypes.node.isRequired,

    isOpen: PropTypes.bool.isRequired,
    classes: PropTypes.string,
    fullscreenOnDevices: PropTypes.bool,

    // functions
    close: PropTypes.func.isRequired
};

export default Popup;



// WEBPACK FOOTER //
// ./src/components/UI/Popup/Popup.js